// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__LkpK0","alert":"SettungsInbox_alert__xSY0q"};